import { render, staticRenderFns } from "./AuthC.vue?vue&type=template&id=4ec0b2b8&scoped=true"
import script from "./AuthC.vue?vue&type=script&lang=js"
export * from "./AuthC.vue?vue&type=script&lang=js"
import style0 from "./AuthC.vue?vue&type=style&index=0&id=4ec0b2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0b2b8",
  null
  
)

export default component.exports